/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreditCardAuthReservation } from './CreditCardAuthReservation';
import {
    CreditCardAuthReservationFromJSON,
    CreditCardAuthReservationFromJSONTyped,
    CreditCardAuthReservationToJSON,
    CreditCardAuthReservationToJSONTyped,
} from './CreditCardAuthReservation';

/**
 * 
 * @export
 * @interface CreditCardAuthQueueResponse
 */
export interface CreditCardAuthQueueResponse {
    /**
     * 
     * @type {Array<CreditCardAuthReservation>}
     * @memberof CreditCardAuthQueueResponse
     */
    reservations: Array<CreditCardAuthReservation>;
}

/**
 * Check if a given object implements the CreditCardAuthQueueResponse interface.
 */
export function instanceOfCreditCardAuthQueueResponse(value: object): value is CreditCardAuthQueueResponse {
    if (!('reservations' in value) || value['reservations'] === undefined) return false;
    return true;
}

export function CreditCardAuthQueueResponseFromJSON(json: any): CreditCardAuthQueueResponse {
    return CreditCardAuthQueueResponseFromJSONTyped(json, false);
}

export function CreditCardAuthQueueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditCardAuthQueueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'reservations': ((json['reservations'] as Array<any>).map(CreditCardAuthReservationFromJSON)),
    };
}

export function CreditCardAuthQueueResponseToJSON(json: any): CreditCardAuthQueueResponse {
    return CreditCardAuthQueueResponseToJSONTyped(json, false);
}

export function CreditCardAuthQueueResponseToJSONTyped(value?: CreditCardAuthQueueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reservations': ((value['reservations'] as Array<any>).map(CreditCardAuthReservationToJSON)),
    };
}

